import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/translation.json";
import urTranslation from "./locales/ur/translation.json";
import trTranslation from "./locales/tr/translation.json";

const resources = {
  en: { translation: enTranslation },
  ur: { translation: urTranslation },
  tr: { translation: trTranslation },
};

const fallbackLng = localStorage.getItem("i18nextLng") || "en";

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: fallbackLng,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
